import * as React from 'react'

export const PriorityCritical = ({
  className,
  strokeColor = '#BF2D37',
  height = 24,
  width = 20,
}: {
  className?: string
  strokeColor?: string
  height?: number
  width?: number
}) => (
  <svg
    className={className}
    fill='none'
    height={height}
    viewBox='0 0 21 24'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.003 5.873v11.745l-9.821 5.873L.36 17.618V5.873L10.182 0l9.82 5.873Zm-11.04 9.535v2.35h2.352v-2.35H8.963Zm.311-9.237v4.504l.343 3.199h1.11l.359-3.2V6.172H9.274Z'
      fill={strokeColor}
    />
  </svg>
)
